import i18n from '../i18n';

const LOCALE_MAP = { es: 'es-ES', en: 'en-US', pt: 'pt-BR' };

function getLocale() {
  return LOCALE_MAP[i18n.language] || 'es-ES';
}

export function formatDate(date, options = { day: 'numeric', month: 'long', year: 'numeric' }) {
  return new Date(date).toLocaleDateString(getLocale(), options);
}

export function formatDateShort(date) {
  return new Date(date).toLocaleDateString(getLocale(), { day: 'numeric', month: 'short', year: 'numeric' });
}

export function formatDateTime(date) {
  const locale = getLocale();
  const d = new Date(date);
  return `${d.toLocaleDateString(locale)} ${d.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })}`;
}
